import React from 'react';
import { size } from 'lodash/fp';
import PropTypes from 'prop-types';
import { Table, Popover } from 'rsuite';
import PathKeyCell from '../../widgets/custom-cell/PathKey';

const { Column, HeaderCell, Cell } = Table;

const computeHeight = (itemsCount = 0, rowHeight = 42, initialHeight = 60) => {
  const maxCount = 5;
  const count = itemsCount >= maxCount ? maxCount : itemsCount;
  return initialHeight + count * rowHeight;
};

const PackageItemsPopover = ({ packageItems, ...props }) => (
  <Popover title="Items" {...props}>
    <Table
      height={computeHeight(size(packageItems))}
      data={packageItems}
      width={300}
    >
      <Column width={120} sortable>
        <HeaderCell>Name</HeaderCell>
        <PathKeyCell dataKey="item.name" />
      </Column>
      <Column width={100} sortable>
        <HeaderCell>Zone</HeaderCell>
        <PathKeyCell dataKey="zone.name" />
      </Column>
      <Column width={60} sortable>
        <HeaderCell>Qty</HeaderCell>
        <Cell dataKey="quantity" />
      </Column>
    </Table>
  </Popover>
);

PackageItemsPopover.propTypes = {
  packageItems: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

export default PackageItemsPopover;
